"use strict";
import axios from "../../../axios";
import deepSeal from "../../../lib/deep_seal";
class Params {
    constructor() {
        Object.assign(this, { "q": { "search_user_query_ids": null, "sheet_name": null }, "sheet_type": null });
        deepSeal(this);
    }
}
class BuildableParams {
    constructor() {
        Object.assign(this, { "q": { "search_user_query_ids": [], "sheet_name": null }, "sheet_type": null });
    }
    build(key) { return {}[key]; }
}
export default {
    Params: Params,
    BuildableParams: BuildableParams,
    execute: function (params) {
        return axios.patch("/jtj/commands/hf_member__create_recommended_users_spread_sheet", { params });
    }
};
